module.exports = __webpack_public_path__ + "static/media/20170620-_DSC064804.e0924b82.jpg";